// Register GSAP ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

function setupAnimations() {
    gsap.from("#anarc-banner .top-content", { opacity: 0, y: 30, scrollTrigger: { trigger: "#anarc-banner", start: "top 70%", end: "top 20%", scrub: true } });
    gsap.from("#anarc-banner .bottom-content", { opacity: 0, y: 30, scrollTrigger: { trigger: "#anarc-banner .bottom-content", start: "top 100%", end: "top 60%", scrub: true } });
    gsap.from("#anarc-watch-slider .top-content", { opacity: 0, y: 30, scrollTrigger: { trigger: "#anarc-watch-slider", start: "top 80%", end: "top 20%", scrub: true } });
    gsap.from("#anarc-watch-slider .bottom-content", { opacity: 0, y: 30, scrollTrigger: { trigger: "#anarc-watch-slider .bottom-content", start: "top 100%", end: "top 60%", scrub: true } });
    gsap.from("#anarc-mid-image-section .section-content-main", { opacity: 0, y: 30, scrollTrigger: { trigger: "#anarc-mid-image-section", start: "top 70%", end: "top 20%", scrub: true } });
    gsap.from("#anarc-mid-image-section .bottom-animation", { opacity: 0, y: 30, scrollTrigger: { trigger: "#anarc-mid-image-section .bottom-animation", start: "top 100%", end: "top 60%", scrub: true } });
    gsap.from("#anarc-brightness-banner .section-content-flex", { opacity: 0, y: 30, scrollTrigger: { trigger: "#anarc-brightness-banner", start: "top 70%", end: "top 20%", scrub: true } });
    gsap.from("#anarc-brightness-banner .bright-bottom-animation", { opacity: 0, y: 30, scrollTrigger: { trigger: "#anarc-brightness-banner .bright-bottom-animation", start: "top 100%", end: "top 60%", scrub: true } });
    gsap.from("#anarc-banner-move-count .top-content", { opacity: 0, y: 30, scrollTrigger: { trigger: "#anarc-banner-move-count", start: "top 70%", end: "top 20%", scrub: true } });
    gsap.from("#anarc-watch-slider-2 .top-content", { opacity: 0, y: 30, scrollTrigger: { trigger: "#anarc-watch-slider-2", start: "top 70%", end: "top 20%", scrub: true } });
    gsap.from("#anarc-banner-3 .bottom-content", { opacity: 0, y: 30, scrollTrigger: { trigger: "#anarc-banner-3 .bottom-content", start: "top 100%", end: "top 60%", scrub: true } });
}

setupAnimations();

window.addEventListener('resize', () => {
    setTimeout(() => {
        ScrollTrigger.refresh();
    }, 550);
});

gsap.ticker.lagSmoothing(0);

var links = document.querySelectorAll('.bar-list a');
links.forEach(function (link) {
    link.addEventListener('click', function (event) {
        event.preventDefault();
        var targetId = this.getAttribute('href').substring(1);
        var targetElement = document.getElementById(targetId);

        if (targetElement) {
            var elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            var offsetPosition = elementPosition - 200;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    });
});

var btns = document.getElementsByClassName("bar-list");
for (var i = 0; i < btns.length; i++) {
    btns[i].addEventListener("click", function () {
        var current = document.getElementsByClassName("active");
        if (current.length > 0) {
            current[0].className = current[0].className.replace(" active", "");
        }
        this.className += " active";
    });
}
